export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11601.38db658c.jpg";